import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Sparkles } from "lucide-react";
import { api, waLink } from "@/lib/api";

export function OfferBanner() {
  const [offer, setOffer] = useState(null);
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" && sessionStorage.getItem("offer_dismissed") === "1"
  );

  useEffect(() => {
    api.get("/settings/offer").then((r) => setOffer(r.data)).catch(() => {});
  }, []);

  const close = () => {
    setDismissed(true);
    sessionStorage.setItem("offer_dismissed", "1");
  };

  const show = offer?.active && offer?.text && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="offer-banner"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="relative z-[55] bg-accent text-accent-foreground overflow-hidden"
        >
          <div className="mx-auto max-w-6xl px-4 py-2.5 flex items-center gap-2">
            <Sparkles className="w-4 h-4 shrink-0" />
            <a
              href={waLink(`Hi The Quisine! I'd like to know about your offer: ${offer.text}`)}
              target="_blank"
              rel="noreferrer"
              className="flex-1 text-sm font-medium leading-snug min-w-0"
            >
              <span className="line-clamp-2">{offer.text}</span>
              {offer.cta_text && (
                <span className="underline underline-offset-2 ml-1 whitespace-nowrap">{offer.cta_text} →</span>
              )}
            </a>
            <button
              data-testid="offer-dismiss"
              onClick={close}
              aria-label="Dismiss offer"
              className="grid place-items-center w-8 h-8 rounded-full hover:bg-black/10 shrink-0"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
